import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

import Shop from './components/Shop';
import Purchases from "./components/purchases/Purchases";
import SharedPage from "./components/shared/SharedPage";
import Print from "./components/Print";
import AccessDenied from "./components/AccessDenied";

const Albums = () => import(/* webpackChunkName: "Albums" */"./components/albums/Albums");
const AlbumDetail = () => import(/* webpackChunkName: "AlbumDetail" */"./components/albums/AlbumDetail");
const PurchaseAlbums = () => import(/* webpackChunkName: "PurchaseAlbums" */"./components/albums/PurchaseAlbums");
const Market = () => import(/* webpackChunkName: "Market" */"./components/purchases/market/Market");
const Clients = () => import(/* webpackChunkName: "Clients" */"./components/purchases/clients/Clients");
const Purchasers = () => import(/* webpackChunkName: "Purchasers" */"./components/purchases/purchasers/Purchasers");
// const PurchaseReport = () => import(/* webpackChunkName: "PurchaseReport" */"./components/purchases/report/PurchaseReport");
const PurchaseHistoryPage = () => import(/* webpackChunkName: "PurchaseHistoryPage" */"./components/purchases/history/PurchaseHistoryPage");
const ShopClients = () => import(/* webpackChunkName: "ShopClients" */"./components/clients/ShopClients");
const ClientEdit = () => import(/* webpackChunkName: "ClientEdit" */"./components/clients/ClientEdit");
const PaymentsList = () => import(/* webpackChunkName: "PaymentsList" */"./components/payments/PaymentsList");
const BalanceHistoryPage = () => import(/* webpackChunkName: "BalanceHistoryPage" */"./components/balance_history/BalanceHistoryPage");
const SettingsPage = () => import(/* webpackChunkName: "SettingsPage" */"./components/settings/SettingsPage");
const CollectionsPage = () => import(/* webpackChunkName: "CollectionsPage" */"./components/collections/CollectionsPage");
const ShareLinksPage = () => import(/* webpackChunkName: "ShareLinksPage" */"./components/purchases/share_link/ShareLinksPage");
const OrderPage = () => import(/* webpackChunkName: "OrderPage" */"./components/orders/OrderPage");
const CollectionPage = () => import(/* webpackChunkName: "CollectionPage" */"./components/collections/CollectionPage");
const CollectionsSort = () => import(/* webpackChunkName: "CollectionsSort" */"./components/collections_sort/CollectionsSort");
const CatalogPage = () => import(/* webpackChunkName: "CatalogPage" */"./components/catalog/CatalogPage");
const CatalogCategoriesPage = () => import(/* webpackChunkName: "CatalogCategoriesPage" */"./components/catalog/CatalogCategoriesPage");
const ProductPage = () => import(/* webpackChunkName: "ProductPage" */"./components/catalog/ProductPage");
const SearchByImagePage = () => import(/* webpackChunkName: "SearchByImage" */"./components/catalog/SearchByImagePage");
const ProductCollectionsPage = () => import(/* webpackChunkName: "ProductCollectionsPage" */"./components/catalog/ProductCollectionsPage");
const FavouritesPage = () => import(/* webpackChunkName: "FavouritesPage" */"./components/favourites/FavouritesPage");

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: '/shared/:uuid/',
            name: 'shared',
            component: SharedPage,
            props: true
        },
        {
            path: '/print/',
            name: 'print',
            component: Print,
            props: false
        },
        {
            path: '/access_denied/',
            name: 'access_denied',
            component: AccessDenied,
            props: false
        },
        {
            path: '/',
            name: 'main',
            component: Shop,
            redirect: '/purchases',
            children: [
                {
                    path: '/',
                    redirect: 'purchases/'
                },
                {
                    path: 'albums/:client_id/',
                    name: 'albums',
                    props: true,
                    component: Albums,
                },
                {
                    path: 'albums/:client_id/:album_id/',
                    name: 'album_detail',
                    props: true,
                    component: AlbumDetail
                },
                {
                    path: 'purchases/',
                    name: 'purchases',
                    props: false,
                    component: Purchases,
                },
                {
                    path: 'purchases/:purchase_id/albums/:client_id/',
                    name: 'purchase_albums',
                    props: true,
                    component: PurchaseAlbums,
                },
                {
                    path: 'purchases/:purchaseId/collections_sort/',
                    name: 'collections_sort',
                    props: true,
                    component: CollectionsSort,
                },
                {
                    path: 'purchases/:purchase_id/albums/:client_id/:album_id/',
                    name: 'purchase_album_detail',
                    props: true,
                    component: AlbumDetail,
                },
                {
                    path: 'purchases/:purchase_id/market/',
                    name: 'purchase_market',
                    props: true,
                    component: Market,
                },
                {
                    path: 'purchases/:purchase_id/clients/',
                    name: 'purchase_clients',
                    props: true,
                    component: Clients,
                },
                {
                    path: 'purchases/:purchase_id/purchasers/',
                    name: 'purchase_purchasers',
                    props: true,
                    component: Purchasers,
                },
                {
                    path: 'purchases/:purchase_id/history/',
                    name: 'purchase_histories',
                    props: true,
                    component: PurchaseHistoryPage,
                },
                {
                    path: 'purchase_history/:client_id/',
                    name: 'client_purchase_history',
                    props: true,
                    component: PurchaseHistoryPage,
                },
                {
                    path: 'purchases/:purchase_id/share_link/',
                    name: 'purchase_share_link',
                    props: true,
                    component: ShareLinksPage,
                },
                {
                    path: 'clients/',
                    name: 'clients',
                    props: false,
                    component: ShopClients,
                },
                {
                    path: 'clients/:client_id/',
                    name: 'client',
                    props: true,
                    component: ClientEdit,
                },
                {
                    path: 'payments/:client_id/',
                    name: 'payments_client',
                    props: true,
                    component: PaymentsList,
                },
                {
                    path: 'payments/',
                    name: 'payments',
                    props: false,
                    component: PaymentsList,
                },
                {
                    path: 'balance_histories/:client_id/',
                    name: 'balance_histories',
                    props: true,
                    component: BalanceHistoryPage,
                },
                {
                    path: 'settings/:section/',
                    name: 'settings_section',
                    props: true,
                    component: SettingsPage,
                },
                {
                    path: 'settings/',
                    name: 'settings',
                    props: false,
                    component: SettingsPage,
                },
                {
                    path: 'collections/',
                    name: 'collections',
                    props: false,
                    component: CollectionsPage,
                },
                {
                    path: 'orders/:order_id/',
                    name: 'order_page',
                    props: true,
                    component: OrderPage,
                },
                {
                    path: 'collections/:collection_id/',
                    name: 'collection_page',
                    props: true,
                    component: CollectionPage,
                },
                {
                    path: 'catalog/',
                    name: 'catalog',
                    props: false,
                    component: CatalogPage,
                },
                {
                    path: 'catalog/categories/',
                    name: 'catalog_categories',
                    props: false,
                    component: CatalogCategoriesPage,
                },
                {
                    path: 'catalog/search-by-image/',
                    name: 'search_by_image',
                    props: false,
                    component: SearchByImagePage,
                },
                {
                    path: 'catalog/:product_id/',
                    name: 'product_page',
                    props: true,
                    component: ProductPage,
                },
                {
                    path: 'catalog/:product_id/collections/',
                    name: 'product_collections',
                    props: true,
                    component: ProductCollectionsPage,
                },
                {
                    path: 'favourites/',
                    name: 'favourites',
                    props: false,
                    component: FavouritesPage,
                }
            ]
        },
    ],
})

router.beforeEach((to, from, next) => {
    if (
        to.name !== 'balance_histories' &&
        store.state.auth.isAuth &&
        !store.getters['clients/has_perm']('immunity_block_site') &&
        store.state.clients.current_client.balance < (store.state.clients.current_client.blocked_balance || store.state.shop.shop.blocked_balance)
    ) {
        next({name: 'balance_histories', params: {client_id: store.state.clients.current_client.id}});
        return;
    }
    next();
});

export default router;
